export const Bio = {
  name: "Rob Eaton",
  roles: [
    "Product Manager",
    "Full Stack Web Developer",
    "UX/UI Designer",
    "Builder",
  ],
  description:
    "I love creating digital experiences that solve real problems.",
  github: "https://github.com/RTE1818",
  resume:
    "https://drive.google.com/file/d/12wAqiFUtD8LU_nxbSqO1iVpr-DIAUnLP/view?usp=sharing",
  linkedin: "https://www.linkedin.com/in/rob-eaton-913112110/",
};

export const skills = [
  {
    title: "My Preferred Tech Stack",
    skills: [
      {
        name: "ReactJs",
        image:
          "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9Ii0xMS41IC0xMC4yMzE3NCAyMyAyMC40NjM0OCI+CiAgPHRpdGxlPlJlYWN0IExvZ288L3RpdGxlPgogIDxjaXJjbGUgY3g9IjAiIGN5PSIwIiByPSIyLjA1IiBmaWxsPSIjNjFkYWZiIi8+CiAgPGcgc3Ryb2tlPSIjNjFkYWZiIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiPgogICAgPGVsbGlwc2Ugcng9IjExIiByeT0iNC4yIi8+CiAgICA8ZWxsaXBzZSByeD0iMTEiIHJ5PSI0LjIiIHRyYW5zZm9ybT0icm90YXRlKDYwKSIvPgogICAgPGVsbGlwc2Ugcng9IjExIiByeT0iNC4yIiB0cmFuc2Zvcm09InJvdGF0ZSgxMjApIi8+CiAgPC9nPgo8L3N2Zz4K",
      },
      {
        name: "NextJs",
        image:
        "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAACTklEQVR4Ab1XAaQqURB9DyohSykREpRIQSAlBCoECKUFCSRCBBEAaSEABQEoCIEASCwAUICALgCo83do0//9v819XX845O7VnDkzOzP7JWGaBd3C3IJpQVjAHeJ+Rs9a97vKLGrBsB1KgMhEP3FMUUwt4ENMfxr1yQIU4SSjRkbeOZtERmHk6pXQVDlnkHh9S+QLTm1hkiz4n/gzFQuny9FoFLquE+i34x+n02k0m00UCoV3BIzn3MMJrVYLtp1OJ0cS/X4f5/MZhmG8IyDsWtDfEaDIn2232/3zbrvdxuFwwGg04qRBt+VnETBNE0IIkE2n07/erdfrWK/X6Ha73Hb9ZXII3G43ivy3dNRqtZe7lUoFs9mM6oBDwCQCgquALT1FT3a5XF7qIZ/PYzgcolqtcggIIgBZAgRKB6lCRalp2uM8k8mAVMrlchwC+DEBipycE4n5fP44j8ViKJVKSCaTbAJCpgaez4vFIsjoWa/XA50FAgEkEgmEw2F2CkxZBZ5Br5tt1ITcbjd8Ph88Hg+7CBefECCsVitS4aVJcV9D/VMCVITk/Hq9YrPZyBBo2a1YMGvAcQYcj0cCtWMugcdYNhjDiBrP25mx3++x3W6RzWZZ8isfxzQLlsslJpMJpYY5jhkqcOH1ejEYDDAej9FoNOByuZxGsfqVzC7KTqcDSkkqleKsZOqX0mAwiHK5DGrJfr+fs5SqX8sjkQji8ThCoRC+v78Za7l6JagrUh3YkUuZpqgwDaecc9VYSDoV5Fg+at7n+eLN57kuE/EvzHr/Kvs31aYAAAAASUVORK5CYII=",
      },
      {
        name: "Supabase",
        image:
          "https://seeklogo.com/images/S/supabase-logo-DCC676FFE2-seeklogo.com.png",
      },
      {
        name: "Tailwind CSS",
        image: "https://upload.wikimedia.org/wikipedia/commons/thumb/d/d5/Tailwind_CSS_Logo.svg/1024px-Tailwind_CSS_Logo.svg.png",
      },
      {
        name: "ShadCn",
        image:
          "data:image/jpeg;base64,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",
      },
      {
        name: "Figma",
        image:
        "https://upload.wikimedia.org/wikipedia/commons/3/33/Figma-logo.svg",
      },
    ],
  },
];

export const projects = [
  {
    id: 0,
    title: "Modern SaaS",
    description:
    "This project features a responsive, heavily animated static landing page for a modern SaaS company.",
    image:
    "/images/modern-saas.png",
    tags: ["NextJs", "Tailwind", "Framer Motion"],
    category: "next-js",
    webapp: "https://ephemeral-blancmange-893d31.netlify.app/",
  },
  {
    id: 1,
    title: "Hotely",
    description:
      "Hotely is a responsive, animated responsive static landing page for a hotel booking website featuring scroll animations using Framer Motion and carousels using SwiperJs.",
      image:
      "/images/hotely.png",
      tags: ["NextJs", "Tailwind", "Framer Motion"],
      category: "next-js",
      webapp: "https://beautiful-mochi-21fffa.netlify.app/",
  },
  {
      id: 2,
      title: "Interno",
      description:
        "Interno is a modern, responsive static landing page for an interior design company including scroll animations using Framer Motion.",
      image:
        "/images/interno.png",
      tags: ["NextJs", "Tailwind", "Framer Motion"],
      category: "next-js",
      webapp: "https://cool-sable-850038.netlify.app/",
  },
  {
    id: 3,
    title: "Happy Home",
    description:
      "Happy Home is a simple, yet elegant responsive static landing page section for a website highlighting the benefits of working remotely.",
    image:
      "/images/happy-home.png",
    tags: ["NextJs", "Tailwind"],
    category: "next-js",
    webapp: "https://rad-croissant-0dcfae.netlify.app/",
  },
  {
    id: 4,
    title: "Finance Dashboard",
    description:
      "This project previews MoneyGo, a static finance dashboard built using Nextjs and Tailwind.",
    image:
      "/images/finance-dashboard.png",
    tags: ["NextJs", "Tailwind"],
    category: "next-js",
    webapp: "https://fastidious-capybara-7cce5f.netlify.app/",
  },
  {
    id: 5,
    title: "Real Estate Brokerage",
    description:
      "Growing up with a father who was a realtor, I couldn't help but appreciate the industry. This project involved building a landing page for a real estate brokerage using HTML, CSS, and vanilla JavaScript. This site is responsive, has a mobile navtive nav menu, has dark / light mode, and includes small js libraries such as Scroll Reveal and Swiper Bundle.",
    image:
      "/images/Real-Estate-Website.png",
      tags: ["HTML", "CSS", "JavaScript"],
    category: "vanilla-js",
    webapp: "https://grand-entremet-f0ddce.netlify.app/",
  },
  {
    id: 6,
    title: "Fitness Website",
    description:
      "As Socrates once said, \"It is a shame for a man to grow old, without seeing the beauty and strength of which his body is capable.\" This project involved building a landing page for a gym using HTML, CSS, and vanilla JavaScript. This site is responsive and includes subtle loading & scrolling animations, a Body Mass Index calculator, and newsletter signup form integrated with Emailjs.",
    image:
      "/images/Responsive-Gym-Website.png",
    tags: ["HTML", "CSS", "JavaScript"],
    category: "vanilla-js",
    webapp: "https://cool-valkyrie-28b109.netlify.app/",
  },
  
];